export const pricingTable = [
  {
    key: "skiSet",
    prices: [12, 24, 34, 44, 56, 66, 8],
  },
  {
    key: "snowboardSet",
    prices: [15, 30, 45, 60, 75, 90, 12],
  },
  {
    key: "skisPoles",
    prices: [10, 20, 28, 36, 44, 52, 7],
  },
  {
    key: "snowboard",
    prices: [10, 20, 30, 40, 50, 60, 8],
  },
  {
    key: "kidsSkis",
    prices: [9, 18, 26, 34, 42, 50, 7],
  },
  {
    key: "boots",
    prices: [7, 14, 21, 28, 35, 42, 6],
  },
  {
    key: "sled",
    prices: [5, 10, 15, 20, 25, 30, 5],
  },
  {
    key: "helmet",
    prices: [4, 8, 12, 16, 20, 24, 4],
  },
  {
    key: "goggles",
    prices: [4, 8, 12, 16, 20, 24, 4],
  },
  {
    key: "jacket",
    prices: [7, 14, 21, 28, 35, 42, 7],
  },
  {
    key: "pants",
    prices: [7, 14, 21, 28, 35, 42, 7],
  },
];
